import styled from 'styled-components'

export default (styled.div || styled.View)`
  padding: ${props => (props.bordered ? '30px' : '30px 0 0 0')};
  border-style: solid;
  border-width: ${props => (props.bordered ? '0px 1px 1px 1px' : '0')};
  border-color: ${props => (props.bordered ? `${props.theme.tabs.tabsLinkBorderColor}` : 'transparent')};
  margin: ${props => (props.bordered ? '0px -1px' : '0')};
`
